var _g, _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoginButton({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 56,
    viewBox: "0 0 160 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4_4188)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 160,
    height: 56,
    fill: "#151515"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 50,
    width: 6,
    height: 6,
    transform: "rotate(-90 0 50)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 56,
    width: 6,
    height: 6,
    transform: "rotate(-90 6 56)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 6,
    width: 6,
    height: 6,
    transform: "rotate(-90 0 6)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 142,
    y: 56,
    width: 6,
    height: 6,
    transform: "rotate(-90 142 56)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 148,
    y: 50,
    width: 6,
    height: 6,
    transform: "rotate(-90 148 50)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 154,
    y: 6,
    width: 6,
    height: 6,
    transform: "rotate(-90 154 6)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 148,
    y: 12,
    width: 6,
    height: 6,
    transform: "rotate(-90 148 12)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 154,
    y: 56,
    width: 6,
    height: 6,
    transform: "rotate(-90 154 56)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.4 36V19.2H49.56V33.96H57.12V36H47.4ZM63.8818 36.216C59.6578 36.216 57.2578 33.624 57.2578 29.04V26.16C57.2578 21.576 59.6578 18.984 63.8818 18.984C68.1058 18.984 70.5058 21.576 70.5058 26.16V29.04C70.5058 33.624 68.1058 36.216 63.8818 36.216ZM59.4178 29.04C59.4178 32.184 60.6418 34.176 63.8818 34.176C67.1218 34.176 68.3458 32.184 68.3458 29.04V26.16C68.3458 23.016 67.1218 21.024 63.8818 21.024C60.6418 21.024 59.4178 23.016 59.4178 26.16V29.04ZM78.5668 36.216C74.3428 36.216 71.9428 33.624 71.9428 29.04V26.16C71.9428 21.576 74.3428 18.984 78.5668 18.984C82.5748 18.984 84.8068 21.36 85.0948 25.032H82.9108C82.6468 22.704 81.5188 21.024 78.5668 21.024C75.3268 21.024 74.1028 23.016 74.1028 26.16V29.04C74.1028 32.184 75.3268 34.176 78.5668 34.176C81.2068 34.176 82.9828 32.952 82.9828 28.968V28.848H78.5428V26.928H85.1428V28.848C85.1428 33.216 83.0788 36.216 78.5668 36.216ZM86.8209 36V34.008H90.3249V21.192H86.8209V19.2H95.9889V21.192H92.4849V34.008H95.9889V36H86.8209ZM98.64 36V19.2H102.696L109.2 35.52V19.2H111.312V36H107.112L100.752 19.8V36H98.64Z",
    fill: "#F5F5F5"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 159.5,
    height: 55.5,
    stroke: "black",
    strokeWidth: 0.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4_4188"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 160,
    height: 56,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginButton);
export default __webpack_public_path__ + "static/media/loginButton.39150957d5f031fc9c037b2553ab574b.svg";
export { ForwardRef as ReactComponent };